import { useEffect, useState } from 'react';
import { listWebchatSites } from '../../services/WebchatService';

/**
 * O setor tem site ativo no chat do site? Decide se a lista de Conversas oferece o filtro "Site".
 * Sem permissão ou com a consulta falhando, fica como "sem site" (nada aparece).
 */
export function useWebchatSite(sectorId: number | null): { webchatActive: boolean } {
  const [webchatActive, setActive] = useState(false);
  useEffect(() => {
    setActive(false);
    if (!sectorId) return;
    let alive = true;
    listWebchatSites(sectorId)
      .then((sites) => {
        if (alive) setActive(sites.some((s) => s.status === 'active'));
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, [sectorId]);
  return { webchatActive };
}
